import { KIT_ACCENTS } from '@/lib/media-kit/accent-palette';

/** Bio colours include the existing account palette and warm creator choices. */
export const BIO_ACCENTS = [
  ...KIT_ACCENTS,
  { name: 'Peach', hex: '#fdba74', rgb: '253 186 116' },
  { name: 'Coral', hex: '#fda4af', rgb: '253 164 175' },
  { name: 'Sage', hex: '#a3c4a8', rgb: '163 196 168' },
];
export const BIO_ACCENT_DESCRIPTION = BIO_ACCENTS.map(
  (accent) => `${accent.name}: ${accent.hex}`,
).join('; ');
